import { render, staticRenderFns } from "./ZDFPlayer.vue?vue&type=template&id=db984716&scoped=true&"
import script from "./ZDFPlayer.vue?vue&type=script&lang=js&"
export * from "./ZDFPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ZDFPlayer.vue?vue&type=style&index=0&id=db984716&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db984716",
  null
  
)

export default component.exports